/*
 * Action Types
 */
export enum SegmentationsTypes {
  LIST_SEGMENTATIONS_REQUEST = '@segmentations/LIST_SEGMENTATIONS_REQUEST',
  LIST_SEGMENTATIONS_SUCCESS = '@segmentations/LIST_SEGMENTATIONS_SUCCESS',
  LIST_SEGMENTATIONS_FAILURE = '@segmentations/LIST_SEGMENTATIONS_FAILURE',

  LIST_SEGMENTATION_VALUES_REQUEST = '@segmentations/LIST_SEGMENTATION_VALUES_REQUEST',
  LIST_SEGMENTATION_VALUES_SUCCESS = '@segmentations/LIST_SEGMENTATION_VALUES_SUCCESS',
  LIST_SEGMENTATION_VALUES_FAILURE = '@segmentations/LIST_SEGMENTATION_VALUES_FAILURE',

  GET_SEGMENTATION_REQUEST = '@segmentations/GET_SEGMENTATION_REQUEST',
  GET_SEGMENTATION_SUCCESS = '@segmentations/GET_SEGMENTATION_SUCCESS',
  GET_SEGMENTATION_FAILURE = '@segmentations/GET_SEGMENTATION_FAILURE',

  CREATE_SEGMENTATION_REQUEST = '@segmentations/CREATE_SEGMENTATION_REQUEST',
  CREATE_SEGMENTATION_SUCCESS = '@segmentations/CREATE_SEGMENTATION_SUCCESS',
  CREATE_SEGMENTATION_FAILURE = '@segmentations/CREATE_SEGMENTATION_FAILURE',

  UPDATE_SEGMENTATION_REQUEST = '@segmentations/UPDATE_SEGMENTATION_REQUEST',
  UPDATE_SEGMENTATION_SUCCESS = '@segmentations/UPDATE_SEGMENTATION_SUCCESS',
  UPDATE_SEGMENTATION_FAILURE = '@segmentations/UPDATE_SEGMENTATION_FAILURE',

  DELETE_SEGMENTATION_REQUEST = '@segmentations/DELETE_SEGMENTATION_REQUEST',
  DELETE_SEGMENTATION_SUCCESS = '@segmentations/DELETE_SEGMENTATION_SUCCESS',
  DELETE_SEGMENTATION_FAILURE = '@segmentations/DELETE_SEGMENTATION_FAILURE',

  CREATE_SEGMENTATIONS_REQUEST = '@segmentations/CREATE_SEGMENTATIONS_REQUEST',
  CREATE_SEGMENTATIONS_SUCCESS = '@segmentations/CREATE_SEGMENTATIONS_SUCCESS',
  CREATE_SEGMENTATIONS_FAILURE = '@segmentations/CREATE_SEGMENTATIONS_FAILURE',

  UPDATE_SEGMENTATIONS_REQUEST = '@segmentations/UPDATE_SEGMENTATIONS_REQUEST',
  UPDATE_SEGMENTATIONS_SUCCESS = '@segmentations/UPDATE_SEGMENTATIONS_SUCCESS',
  UPDATE_SEGMENTATIONS_FAILURE = '@segmentations/UPDATE_SEGMENTATIONS_FAILURE',

  DELETE_SEGMENTATIONS_REQUEST = '@segmentations/DELETE_SEGMENTATIONS_REQUEST',
  DELETE_SEGMENTATIONS_SUCCESS = '@segmentations/DELETE_SEGMENTATIONS_SUCCESS',
  DELETE_SEGMENTATIONS_FAILURE = '@segmentations/DELETE_SEGMENTATIONS_FAILURE',
}

/*
 * Data types
 */
export interface SegmentationDataInterface {
  name: string;
  attribute: string;
  selected: string;
  value: string;
}

export interface SegmentationAttributesInterface {
  name: string;
  title: string;
  type: 'NUMBER' | 'ENUM' | 'UUID';
  values: string[];
  operations?: string[];
}

export interface SegmentationValuesInterface {
  name: string;
  title: string;
  attributes: SegmentationAttributesInterface[];
}

export interface SegmentationInterface {
  id: string;
  name?: string;
  title: string;
  description: string;
  estimation: number;
  data: object[];
  createdAt: string;
  updatedAt: string;
}

/*
 * State type
 */
export interface SegmentationsState {
  readonly segmentations: SegmentationInterface[];
  readonly segmentationData: SegmentationInterface;
  readonly segmentationValues: SegmentationValuesInterface[];
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
